import { EnabledIconProps, IconProps } from './IconProps';

export const EdgeIcon = ({
  className,
  height = 9,
  width = 11,
  enabled = false,
}: IconProps & EnabledIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 9 11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.033 0C1.81 0 0 1.921 0 4.283c0 2.306 3.728 6.474 3.886 6.65a.198.198 0 0 0 .147.067.198.198 0 0 0 .147-.067c.159-.176 3.887-4.344 3.887-6.65C8.067 1.92 6.257 0 4.033 0"
      fill={enabled ? '#2396FD' : '#B2B2B2'}
      fillRule="evenodd"
    />
  </svg>
);
